export default __webpack_public_path__ + "static/media/sophia_lin.5fb825cd.jpg";